import { Component, Input } from '@angular/core';
import * as _ from 'lodash';

@Component({
    selector: 'simple-data-table',
    template: require('./simple-data-table.component.html'),
  })
  export class SimpleDataTableComponent {
    @Input() expanded: boolean = false;
    @Input() labelField: string = '';
    @Input() valueField: string = '';
    @Input() rows: any[] = [];
  
    constructor() {}
  
    toggleData() {
      this.expanded = !_.get(this, 'expanded', false);
    }
  }
